export default __webpack_public_path__ + "static/media/a3.35887300.png";